import { environment as defaultEnvironment } from "./environment.default";

export const environment = {
  ...defaultEnvironment,
  production: true,
  fullUrl: "https://technomad.fr",
  // collectifUrl: "https://collectif.technomad.fr",
  collectifUrl: "https://linktr.ee/technomad.collectif",
  audioUrl: "https://audio.technomad.fr",
};
